const getMetaData = (data, term, language) => {
  return data[term][language] || data[term].en;
};

export default getMetaData;



// WEBPACK FOOTER //
// ../src/utils/getMetaData.js